/*
 * One variant of a Collaterate storefront stock product, such as its red one in medium.
 *
 * @property {number} id - (Read only) The variant's id, the one `ProductImage.variantIds` and the stock product page's
 *     `collaterate:productVariantChanged` use.
 * @property {string[]} choices - (Read only) Its choice for each of the product's attributes, in order, such as
 *     `['Red', 'M']`; null for an attribute it has no choice for.
 */

const FROM_END = 1;

class ProductVariant {
    constructor (data) {
        Object.defineProperties(this, {
            id: {
                value: data.variantId,
                enumerable: true,
            },
            choices: {
                value: choicesOf(data),
                enumerable: true,
            },
        });
    }
}

export default ProductVariant;

function choicesOf (data) {
    const choices = [data.attribute1Choice, data.attribute2Choice, data.attribute3Choice].map(choice => choice || null);
    while (choices.length && choices[choices.length - FROM_END] === null) {
        choices.pop();
    }
    return Object.freeze(choices);
}
